import PropTypes from 'prop-types';
import React from 'react'

var icons = {

	default: {
		type: '',
		className: ''
	},

    accept: {
		type: 'linearicons',
		className: 'thumbs-up'
    },
    activity: {
		type: 'linearicons',
		className: 'list'
    },
    articles: {
		type: 'linearicons',
		className: 'document2'
    },
    badges: {
		type: 'linearicons',
		className: 'medal-empty'
    },
    billing: {
		type: 'linearicons',
		className: 'credit-card'
    },
    bookmarks: {
		type: 'linearicons',
		className: 'bookmark2'
    },
    camps: {
		type: 'linearicons',
		className: 'home3'
    },
    comments: {
		type: 'linearicons',
		className: 'bubble-dots'
    },
    currency: {
    	type: 'custom',
    	text: '฿'
    },
    facebook: {
		type: 'font-awesome',
		className: 'facebook'
    },
    flares: {
		type: 'linearicons',
		className: 'fire'
    },
    global: {
		type: 'linearicons',
		className: 'earth'
    },
    googleplus: {
		type: 'font-awesome',
		className: 'google-plus'
    },
    history: {
		type: 'linearicons',
		className: 'clock3'
    },
    interests: {
		type: 'linearicons',
		className: 'flag'
    },
    linkedin: {
		type: 'font-awesome',
		className: 'linkedin'
    },
    menu: {
		type: 'linearicons',
		className: 'menu'
    },
    notificationsEmpty: {
		type: 'linearicons',
		className: 'alarm'
    },
    notifications: {
		type: 'linearicons',
		className: 'alarm-ringing'
    },
    refresh: {
		type: 'linearicons',
		className: 'sync2'
    },
    reject: {
		type: 'linearicons',
		className: 'thumbs-down'
    },
    replies: {
		type: 'linearicons',
		className: 'bubbles'
    },
    remove: {
		type: 'linearicons',
		className: 'skull'
    },
    search: {
		type: 'linearicons',
		className: 'magnifier'
    },
    settings: {
		type: 'linearicons',
		className: 'cog'
    },
    statements: {
		type: 'linearicons',
		className: 'bullhorn'
    },
    twitter: {
		type: 'font-awesome',
		className: 'twitter'
    },
    workshops: {
		type: 'linearicons',
		className: 'graduation-hat'
    }

}

export default class extends React.Component {
    static propTypes = {
		icon: PropTypes.string.isRequired,
		className: PropTypes.string,
		onClick: PropTypes.oneOfType([
			PropTypes.bool,
			PropTypes.func
		])
	};

    constructor(props, context) {
        super(props, context);

        let { className, icon } = props,
    		iconData = this.get( icon );

        this.state = { icon: iconData };
    }

    shouldComponentUpdate() {
		return false;
	}

    get = (icon) => {

    	if( typeof icons[icon] === 'undefined' ) icon = 'default'

		let iconData = Object.assign({}, icons[icon]);

		switch( iconData.type ) {
			case 'font-awesome':
				iconData.className = "fa fa-" + iconData.className;
				break;
			case 'linearicons':
				iconData.className = "icon-" + iconData.className;
				break;
		}

		return iconData;

    };

    onClick = () => {
    	if( !this.props.onClick ) return false;
    	this.props.onClick()
    };

    render() {

    	let { icon } = this.state,
    		{ className } = this.props;

		if( !!className ) icon.className += ' ' + className;

    	return (
    		<i className={icon.className} onClick={this.onClick}>
    			{'text' in icon ? icon.text : ''}
			</i>
		)

    }
}



// WEBPACK FOOTER //
// ./src/js/components/Icon.js